/**
 * Vruchtvlees © 2007-2019
 *
 * Hi, welcome!
 *
 * This is the main Javscript file.
 * One script to rule them all!
 * Let's go and godspeed you!
 */

/** ----------------------------------------
    Webpack Settings
 ---------------------------------------- */

// eslint-disable-next-line
let webpack = SETTINGS;

/** ----------------------------------------
    Environment
 ---------------------------------------- */

/**
 * This class will check the current
 * environment of the website and stores
 * an object with information about the
 * current environment.
 */

import { Environment } from '@helper/Environment.js';

const host = new Environment({
    webpack: webpack
});

/** ----------------------------------------
    Set Style Guide
 ---------------------------------------- */

/**
 * This section will set the VV Style Guide
 * as a default for at the index.html.
 *
 * You can mess around with the information
 * it will be displayed within the page.
 */

import { Style } from '@js/style/Style.js';

let info = {
    title: 'Vruchtvlees Digital Style Guide',
    intro: 'This style guide provides guidelines for the digital design as configured within the SASS stylesheets. It will automatically extend and change once you start working on the project. If certain elements or blocks should be left out these can be configured within the config.js file related to the style guide. It serves as a guide to quickly check what variables have been configured, what names they use and how the styling of a certain element has been affected within the stylesheet. Godspeed you!',
};

let config = {
    breakpoints: true,
    grid: true,
    typo: true,
    letters: true,
    colors: true,
    headings: true,
    text: true,
    content: true,
    font: true,
    links: true,
    tooltip: true,
    forms: true,
    lists: true,
    tables: true,
    buttons: true,
    icons: true
};

const style = new Style(info, config, webpack.config.development && webpack.config.guide);

if(!host.info.environment.live) {
    log.section('VV', 'Style');
    style.log();
}

/** ----------------------------------------
    Brakkegrond Jaarverslag
 ---------------------------------------- */

/**
 * Here the code starts for the brakkegrond jaarverslag
 */

import $ from 'jquery';
import { offset, isInt, inView } from './helpers/Misc.js';

/** ----------------------------------------
    Menu toggle
 ---------------------------------------- */

const menu = document.querySelector('.menu');

const menuToggle = () => {
    const hamburger = document.querySelector('.js-toggle-menu');
    
    hamburger.addEventListener('click', function (event) {
        menu.classList.contains('menu--open') ? menu.classList.remove('menu--open') : menu.classList.add('menu--open');
    }, false);
}

/** ----------------------------------------
    Menu items click
 ---------------------------------------- */

const updateChapterCoords = (chapterIntros) => {
    const chapterCoords = [];
    
    chapterIntros.forEach(intro => {
        chapterCoords.push({
            y: offset(intro).top,
            name: intro.getAttribute('chapter').toLowerCase()
        });
    })

    return chapterCoords
}

const menuItems = () => {
    const menuItems = document.querySelectorAll('.menu__item');
    const chapterIntros = document.querySelectorAll('.chapter-intro');
    let chapterCoords = updateChapterCoords(chapterIntros);
     
    menuItems.forEach(item => {
        item.addEventListener('click', function (event) {
            chapterCoords = updateChapterCoords(chapterIntros);
            const targetName = item.getAttribute('target').toLowerCase();

            chapterCoords.forEach(chapter => {
                if (chapter.name == targetName) {
                    $('html,body').animate({
                        scrollTop: chapter.y - 55
                    }, 'slow');
                    menu.classList.remove('menu--open');
                }
            });
            
        }, false);
    })
}

/** ----------------------------------------
 Video
 ---------------------------------------- */

import { Video } from './module/video';

const videosElems = document.querySelectorAll('.video');
const videos = [];

for (let videoEl of videosElems) {
    videos.push(new Video(videoEl));
}

/** ----------------------------------------
    Adjust grid
 ---------------------------------------- */

 const adjustGrid = (className) => {
    let grids = document.querySelectorAll(className);

    grids.forEach(grid => {
        let gridItems = grid.querySelectorAll('.grid__item')
        let heights = [];

        gridItems.forEach(gridItem => {
            heights.push(gridItem.offsetHeight);
        })

        let max = Math.max(...heights);

        gridItems.forEach(gridItem => {
            gridItem.style.height = `${max}px`;
        })
    })
 }

/** ----------------------------------------
    AOS - animate when on view
 ---------------------------------------- */

import AOS from 'aos';

const animateTransitions = () => {
    AOS.init({
        offset: 0,
        duration: 1000,
        delay: 0,
    });
}

/** ----------------------------------------
    Accordion
 ---------------------------------------- */

const accordion = () => {
    const accordions = document.querySelectorAll('.js-accordion');

    accordions.forEach(el => {

        const parent = el.querySelector('.accordion__parent');
        const childrenWrap = el.querySelector('.accordion__items');
        const children = el.querySelectorAll('.accordion__item');
        const unitHeight = parent.offsetHeight;

        parent.addEventListener('click', function (event) {

            if(parent.classList.contains('is-active')) {
                parent.classList.remove('is-active');
                childrenWrap.style.height = `0px`;
            } else {
                parent.classList.add('is-active');
                childrenWrap.style.height = `${ children.length * unitHeight }px`;
            }
            
        }, false);
    })
}

/** ----------------------------------------
    Animate numbers
 ---------------------------------------- */

 import { CountUp } from 'countup.js';

 const countUpElements = document.querySelectorAll('.js-count-up');
 
 const initCountUp = (el) => {
     const number = parseFloat(el.getAttribute('number'));
     if (!number) return;
 
     const options = {
         decimalPlaces: 0,
         separator: '.',
         decimal: ',',
         duration: 1.4,
     };
 
     let demo = new CountUp(el, number, options);
 
     if (!demo.error) {
       demo.start();
     } else {
       console.error(demo.error);
     }
 }

/** ----------------------------------------
    Chapter bar
 ---------------------------------------- */

const bar = document.querySelector('.chapter-intro-bar');
const barInner = bar.querySelector('.chapter-intro-bar__inner');
const chapters = document.querySelectorAll('.chapter-intro');

window.onscroll = function() {
    chapters.forEach(chapter => {
        if(window.pageYOffset > offset(chapter).top) {
            let title = chapter.getAttribute('menutitle')
            barInner.innerHTML = title;
            bar.classList.add('is-active')
        }
    })

    if (window.pageYOffset < offset(chapters[0]).top) {
        bar.classList.remove('is-active')
    }

    countUpElements.forEach(el => {
        if (inView(el)) {
            if (parseFloat(el.innerHTML) <= 0) {
                initCountUp(el)
            }
        }

    })
};

/** ----------------------------------------
    Slider
---------------------------------------- */

import slick from 'slick-carousel';

const slider = () => {
    $('.js-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow: '<div class="slider__arrow slider__arrow--previous highlight-home__arrow--previous"></div>',
        nextArrow: '<div class="slider__arrow slider__arrow--next highlight-home__arrow--next"></div>',
    });
}

/** ----------------------------------------
    IE Check
 ---------------------------------------- */

const isIe = () => {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
    {
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    } else {
        return false;
    }
}   

/** ----------------------------------------
    Dom Loaded
 ---------------------------------------- */

document.addEventListener("DOMContentLoaded", function() {
    menuToggle();
    adjustGrid('.adjust-grid');
    accordion();
    slider();

    setTimeout(() => {
        !isIe() && animateTransitions();
        menuItems();
    },1500)
});
